import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  namespaced: true,
  state: {
    user: {
      test: ''
    }
  },

  mutations: {
    // todo
    AddInfo (state, data) {
      // todo with state
    }
  },
  actions: {
    addInfo ({commit}, data) {
      commit('AddInfo', data)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js